import { render } from "./RedesignToggle.vue?vue&type=template&id=ed587aa6&scoped=true"
import script from "./RedesignToggle.vue?vue&type=script&lang=js"
export * from "./RedesignToggle.vue?vue&type=script&lang=js"

import "./RedesignToggle.vue?vue&type=style&index=0&id=ed587aa6&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed587aa6"]])

export default __exports__